// src/crypto/b64.ts
// 跨 JSON 传输统一用标准 base64（带 = padding，与 SEC §2.3 一致）。
// 本地存 Uint8Array；线上 JSON 才走 base64。
export function bytesToBase64(bytes) {
    let s = "";
    for (let i = 0; i < bytes.length; i++)
        s += String.fromCharCode(bytes[i]);
    // btoa is fine for small payloads; for large media use chunked path
    return btoa(s);
}
export function base64ToBytes(b64) {
    const bin = atob(b64);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++)
        out[i] = bin.charCodeAt(i);
    return out;
}
// base64url (no padding) — 用于 URL 安全场景（reset token 等）
export function bytesToBase64Url(bytes) {
    return bytesToBase64(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
export function base64UrlToBytes(s) {
    let b64 = s.replace(/-/g, "+").replace(/_/g, "/");
    while (b64.length % 4)
        b64 += "=";
    return base64ToBytes(b64);
}
